import api from '@/api/axios';

/**
 * Serviço para gerenciar configuração de background
 * Salva/carrega do servidor via API
 */
export default {
  /**
   * Carrega configuração de background do servidor
   * @returns {Promise<Object>} Configuração salva
   */
  async loadConfig() {
    try {
      const response = await api.get('/background-config');
      console.log('✅ Configuração carregada do servidor com sucesso');
      return response.data;
    } catch (error) {
      // Qualquer erro (404, network, CORS, etc) - usa configuração padrão
      const defaultConfig = {
        selectedBgColor: '#00235C',
        selectedGradient: 'default',
        selectedGradientType: 'linear',
        formStyling: {
          enabled: {
            mobile: false,
            tablet: false,
            desktop: false
          },
          currentEditingDevice: 'mobile',
          mobile: {
            mode: 'dark',
            width: '100%',
            minWidth: '0px',
            maxWidth: '600px',
            backgroundColor: '#FFFFFF',
            opacity: 10,
            alignment: 'center',
            alignmentOffset: 6,
            logoInvert: false,
            textColor: '#FFFFFF',
            inputBgEnabled: '#FFFFFF',
            inputBgDisabled: '#F3F4F6',
            inputTextColor: '#000000',
            buttonTextColor: '#FFFFFF',
            buttonColorType1: '#3b82f6',
            buttonOpacityType1: 100,
            buttonColorType2: '#FFFFFF',
            buttonOpacityType2: 20,
            customTexts: {
              preLoginTitle: { enabled: false, content: 'Olá, Seja Bem-vindo!' },
              preLoginSubtitle: { enabled: false, content: 'Gerencie suas operações com segurança' },
              formTitle: { enabled: false, content: 'Acesse Sua Conta' },
              formSubtitle: { enabled: false, content: 'Insira seus dados para continuar.' },
              recoverTitle: { enabled: false, content: 'Recuperar senha' },
              recoverSubtitle: { enabled: false, content: 'Digite seus dados para recuperar o acesso.' }
            }
          },
          tablet: {
            mode: 'dark',
            width: '100%',
            minWidth: '0px',
            maxWidth: '800px',
            backgroundColor: '#FFFFFF',
            opacity: 10,
            alignment: 'center',
            alignmentOffset: 12,
            logoInvert: false,
            textColor: '#FFFFFF',
            inputBgEnabled: '#FFFFFF',
            inputBgDisabled: '#F3F4F6',
            inputTextColor: '#000000',
            buttonTextColor: '#FFFFFF',
            buttonColorType1: '#3b82f6',
            buttonOpacityType1: 100,
            buttonColorType2: '#FFFFFF',
            buttonOpacityType2: 20,
            customTexts: {
              preLoginTitle: { enabled: false, content: 'Olá, Seja Bem-vindo!' },
              preLoginSubtitle: { enabled: false, content: 'Gerencie suas operações com segurança' },
              formTitle: { enabled: false, content: 'Acesse Sua Conta' },
              formSubtitle: { enabled: false, content: 'Insira seus dados para continuar.' },
              recoverTitle: { enabled: false, content: 'Recuperar senha' },
              recoverSubtitle: { enabled: false, content: 'Digite seus dados para recuperar o acesso.' }
            }
          },
          desktop: {
            mode: 'dark',
            width: '100%',
            minWidth: '0px',
            maxWidth: '1000px',
            backgroundColor: '#FFFFFF',
            opacity: 10,
            alignment: 'center',
            alignmentOffset: 16,
            logoInvert: false,
            textColor: '#FFFFFF',
            inputBgEnabled: '#FFFFFF',
            inputBgDisabled: '#F3F4F6',
            inputTextColor: '#000000',
            buttonTextColor: '#FFFFFF',
            buttonColorType1: '#3b82f6',
            buttonOpacityType1: 100,
            buttonColorType2: '#FFFFFF',
            buttonOpacityType2: 20
          }
        },
        lastUpdated: null
      };
      
      if (error.response) {
        // Erro de resposta do servidor (404, 500, etc)
        console.log(`ℹ️ Backend retornou ${error.response.status}, usando configuração padrão`);
      } else if (error.request) {
        // Requisição foi feita mas não houve resposta (timeout, network error)
        console.log('⚠️ Backend não respondeu (endpoint não implementado?), usando configuração padrão');
      } else {
        // Erro ao configurar a requisição
        console.log('⚠️ Erro ao fazer requisição:', error.message);
      }
      
      return defaultConfig;
    }
  },

  /**
   * Salva configuração de background no servidor
   * @param {Object} config - Configuração a ser salva
   * @returns {Promise<Object>} Resposta do servidor
   */
  async saveConfig(config) {
    try {
      const response = await api.post('/background-config', config);
      return response.data;
    } catch (error) {
      console.error('❌ Erro ao salvar config de background no servidor:', error);
      throw error;
    }
  },

  async uploadImage(formData) {
    try {
      const response = await api.post('/background-config/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao fazer upload da imagem:', error);
      throw error;
    }
  },

  async deleteImages() {
    try {
      const response = await api.delete('/background-config/images');
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar imagens:', error);
      throw error;
    }
  },

  async getImages() {
    try {
      const response = await api.get('/background-config/images');
      return response.data;
    } catch (error) {
      // Se não houver imagens customizadas, retorna objeto vazio
      if (error.response?.status === 404) {
        return {
          mobile: null,
          tablet: null,
          desktop: null
        };
      }
      console.error('Erro ao buscar imagens:', error);
      throw error;
    }
  }
};
